export const FETCH_STATISTICS_START = 'FETCH_STATISTICS_START';
export const FETCH_STATISTICS_SUCCESS = 'FETCH_STATISTICS_SUCCESS';
export const FETCH_STATISTICS_FAIL = 'FETCH_STATISTICS_FAIL';

export type StatisticsActionTypes =
  | typeof FETCH_STATISTICS_START
  | typeof FETCH_STATISTICS_SUCCESS
  | typeof FETCH_STATISTICS_FAIL;
